export const InitialData = {
  isLoading: false,
  addresses: [],
  companies: [],
};

export const emptyData = {};
